import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const tabsContainer: CSSProperties = {
  display: 'flex',
  position: 'sticky',
  top: 0,
  left: 0,
  right: 0,
  width: '100%',
  zIndex: 3,
  borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
};

export const tab: CSSProperties = {
  flex: 1,
  padding: '12px',
  textAlign: 'center',
  color: '#1A1A1A',
  backgroundColor: 'white',
  border: 'none',
  cursor: 'pointer',
  fontSize: '15px',
  fontWeight: '500',
  outline: 'none',
  background: UIConfig.Colors.BackgroundWhite
};

export const selectedTab: CSSProperties = {
  fontWeight: '600'
};

export const previewTab: CSSProperties = {
  fontWeight: '600',
  color: UIConfig.Colors.BackgroundWhite
};

export const allTabsBlackBackground: CSSProperties = {
  backgroundColor: UIConfig.Colors.BackgroundDark,
  color: 'white'
};

export const verticalSeparator: CSSProperties = {
  width: '1px',
  backgroundColor: 'rgba(0, 0, 0, 0.08)'
};

export const pageContainerStyle: CSSProperties = {
  position: 'fixed',
  top: 100,
  left: 0,
  width: '100%',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  overflow: 'auto'
};

export const svgContainerStyle: CSSProperties = {
  marginTop: '50px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};

export const iconCircleStyle: CSSProperties = {
  width: '64px',
  height: '64px',
  backgroundColor: '#1A1A1A',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '14px',
  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)'
};

export const innerCircleStyle: CSSProperties = {
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

export const titleStyle: CSSProperties = {
  fontSize: '20px',
  width: '80vw',
  fontWeight: '600',
  textAlign: 'center',
  color: '#1A1A1A',
  letterSpacing: '-0.3px'
};
